import React, { useState } from 'react';

import {
  Box,
  Typography,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  TableFooter,
} from '@mui/material';

const ENTRIES = [
  { id: 'YAM-8842', status: 'error', currency: 'USD', supplier: 'Tokyo Moto Systems LTD.', incoterm: 'CIF Los Angeles', date: '2026-02-14', desc: '400cc Engine Blocks', cooMatchText: 'ACE Match Confirmed', cooStatus: '✓ Matched', htsMatchText: 'ACE Match Confirmed', htsStatus: '✓ Matched', dutiable: '$180,000.00 USD', nondutiable: '$4,500.00 USD', total: '$184,500.00 USD', declared: '$184,500.00 USD', tariff: '25% (Sec 301)', variance: '+$1,125.00 USD', errorType: 'Ocean Freight', reason: 'CRITICAL: Incoterm is CIF. Freight must be deducted from total. Broker declared total invoice value ($184,500) as entered value. Resulting in $1,125 tariff overpayment.', logic: 'If Incoterm = CIF, then Entered Value = Total - Freight - Insurance.' },
  { id: 'YAM-8843', status: 'clean', currency: 'USD', supplier: 'Osaka Electronics Co.', incoterm: 'FOB Tokyo', date: '2026-02-15', desc: 'Instrument Clusters', cooMatchText: 'ACE Match Confirmed', cooStatus: '✓ Matched', htsMatchText: 'ACE Match Confirmed', htsStatus: '✓ Matched', dutiable: '$42,000.00 USD', nondutiable: '$0.00 USD', total: '$42,000.00 USD', declared: '$42,000.00 USD', tariff: '10%', variance: '$0.00', errorType: 'N/A', reason: 'Validation Complete: Incoterm FOB verified. No freight deductions required. Entered value matches CI.', logic: 'If Incoterm = FOB, then Entered Value = Total Invoice Value.' },
  { id: 'YAM-8844', status: 'error', currency: 'USD', supplier: 'Kyoto Logistics Parts', incoterm: 'EXW Kyoto', date: '2026-02-16', desc: 'Braking Calipers', cooMatchText: 'ACE Match Confirmed', cooStatus: '✓ Matched', htsMatchText: 'ACE Match Confirmed', htsStatus: '✓ Matched', dutiable: '$65,000.00 USD', nondutiable: '$2,000.00 USD', total: '$67,000.00 USD', declared: '$67,000.00 USD', tariff: '15%', variance: '+$300.00 USD', errorType: 'Buying Commission', reason: 'CRITICAL: Broker rolled non-dutiable buying commission into entered value on the 7501.', logic: 'Buying Commissions explicitly identified in footnotes are non-dutiable.' },
  { id: 'YAM-8845', status: 'error', currency: 'USD', supplier: 'Yamaha Corp Japan', incoterm: 'FCA Yokohama', date: '2026-02-16', desc: 'Motorcycle Component Assortment', cooMatchText: 'ACE Match Confirmed', cooStatus: '✓ Matched', htsMatchText: 'Line-Level Validation (See Screen 2)', htsStatus: '⚠️ Class Error', dutiable: '$112,000.00 USD', nondutiable: '$0.00 USD', total: '$112,000.00 USD', declared: '$112,000.00 USD', tariff: 'Multi', variance: '+$11,200.00 USD', errorType: 'HTS Classification', reason: 'CRITICAL NLP MISMATCH: AI mapped product descriptions to specific HTSUS chapters (Free). 3rd-party broker incorrectly filed generic parts codes (10%). Overpayment generated purely on classification error.', logic: 'NLP Ontology Check: Plain English product descriptions semantically mapped to USITC HTSUS database.', lineItems: [{ desc: 'Suspension Forks [AI: 8714.10 / ACE: 8714.99]', declared: '$60,000.00 USD', dutiable: '$60,000.00 USD', tariff: 'ACE: 10% | AI: 0%', variance: '+$6,000.00 USD' }, { desc: 'Exhaust Pipes [AI: 8714.10 / ACE: 8714.99]', declared: '$52,000.00 USD', dutiable: '$52,000.00 USD', tariff: 'ACE: 10% | AI: 0%', variance: '+$5,200.00 USD' }] },
  { id: 'YAM-8846', status: 'error', currency: 'USD', supplier: 'Nagoya Precision', incoterm: 'CIF Seattle', date: '2026-02-17', desc: 'Transmission Gears', cooMatchText: 'ACE Match Confirmed', cooStatus: '✓ Matched', htsMatchText: 'ACE Match Confirmed', htsStatus: '✓ Matched', dutiable: '$88,000.00 USD', nondutiable: '$1,200.00 USD', total: '$89,200.00 USD', declared: '$89,200.00 USD', tariff: '25%', variance: '+$300.00 USD', errorType: 'Marine Insurance', reason: 'CRITICAL: Insurance cost bundled in CIF terms was not backed out of the declared value.', logic: 'If Incoterm = CIF, Insurance is non-dutiable.' },
  { id: 'YAM-8857', status: 'error', currency: 'USD', supplier: 'Osaka Electronics Co.', incoterm: 'FCA Tokyo', date: '2026-02-17', desc: 'Control Boards', cooMatchText: 'Line-Level Validation (See Screen 2)', cooStatus: '⚠️ Origin Error', htsMatchText: 'ACE Match Confirmed', htsStatus: '✓ Matched', dutiable: '$80,000.00 USD', nondutiable: '$0.00 USD', total: '$80,000.00 USD', declared: '$80,000.00 USD', tariff: 'Multi', variance: '+$20,000.00 USD', errorType: 'Country of Origin', reason: 'CRITICAL: Supplier invoice explicitly states parts are manufactured in Japan. 3rd-party broker accidentally keyed "CN" (China) on the 7501 line item, triggering a massive, erroneous 25% Section 301 tariff overpayment.', logic: 'Origin string match: AI extracted "Origin: Japan". ACE 7501 line filed as "CN".', lineItems: [{ desc: 'Control Boards [Origin: JP (AI) / CN (ACE)]', declared: '$80,000.00 USD', dutiable: '$80,000.00 USD', tariff: 'ACE: 35% | AI: 10%', variance: '+$20,000.00 USD' }] },
  { id: 'YAM-8848', status: 'clean', currency: 'USD', supplier: 'Sapporo Steel Works', incoterm: 'FOB Tokyo', date: '2026-02-18', desc: 'Raw Steel Tubing', cooMatchText: 'ACE Match Confirmed', cooStatus: '✓ Matched', htsMatchText: 'ACE Match Confirmed', htsStatus: '✓ Matched', dutiable: '$45,000.00 USD', nondutiable: '$0.00 USD', total: '$45,000.00 USD', declared: '$45,000.00 USD', tariff: '10%', variance: '$0.00', errorType: 'N/A', reason: 'Validation Complete.', logic: 'Standard extraction.' },
  { id: 'YAM-8849', status: 'error', currency: 'USD', supplier: 'Sendai Packaging Co', incoterm: 'DDP Los Angeles', date: '2026-02-18', desc: 'Crate Materials', cooMatchText: 'ACE Match Confirmed', cooStatus: '✓ Matched', htsMatchText: 'ACE Match Confirmed', htsStatus: '✓ Matched', dutiable: '$12,000.00 USD', nondutiable: '$800.00 USD', total: '$12,800.00 USD', declared: '$12,800.00 USD', tariff: '5%', variance: '+$40.00 USD', errorType: 'U.S. Inland Freight', reason: 'CRITICAL: DDP terms include U.S. domestic freight, which is non-dutiable.', logic: 'If Incoterm = DDP, domestic transit costs must be excluded.' },
  { id: 'YAM-8850', status: 'warning', currency: 'JPY', supplier: 'Tokyo Moto Systems LTD.', incoterm: 'FOB Yokohama', date: '2026-02-19', desc: '400cc Engine Blocks', cooMatchText: 'ACE Match Confirmed', cooStatus: '✓ Matched', htsMatchText: 'ACE Match Confirmed', htsStatus: '✓ Matched', dutiable: '¥13,500,000 JPY', nondutiable: '¥0 JPY', total: '¥13,500,000 JPY', declared: '$90,000.00 USD', tariff: 'N/A', variance: 'Manual Review', errorType: 'Date Mismatch / FX Conversion', reason: 'ACTION REQUIRED: Invoice billed in non-USD currency. Diverting to Human LCB queue to extract actual BOL export date and verify correct NY Fed FX rate was applied per 19 CFR § 159.', logic: 'If Currency != USD, flag for human FX review.' },
  { id: 'YAM-8851', status: 'clean', currency: 'USD', supplier: 'Tokyo Moto Systems LTD.', incoterm: 'FOB Yokohama', date: '2026-02-19', desc: '400cc Engine Blocks', cooMatchText: 'ACE Match Confirmed', cooStatus: '✓ Matched', htsMatchText: 'ACE Match Confirmed', htsStatus: '✓ Matched', dutiable: '$90,000.00 USD', nondutiable: '$0.00 USD', total: '$90,000.00 USD', declared: '$90,000.00 USD', tariff: '25%', variance: '$0.00', errorType: 'N/A', reason: 'Validation Complete.', logic: 'Standard extraction.' },
  { id: 'YAM-8852', status: 'error', currency: 'USD', supplier: 'Kobe Heavy Ind.', incoterm: 'CIF Long Beach', date: '2026-02-20', desc: 'Mixed Machinery', cooMatchText: 'ACE Match Confirmed', cooStatus: '✓ Matched', htsMatchText: 'Line-Level Validation (See Screen 2)', htsStatus: '✓ Matched', dutiable: '$210,000.00 USD', nondutiable: '$6,500.00 USD', total: '$216,500.00 USD', declared: '$216,500.00 USD', tariff: 'Multi', variance: '+$1,137.50 USD', errorType: 'Ocean Freight & Insurance', reason: 'CRITICAL: Broker failed to perform CIF deduction. Non-dutiable freight ($6,500) was prorated across multiple HTS lines by value, inflating the duty calculation across different tariff tiers.', logic: 'If Incoterm = CIF, deduct Freight and Insurance (Prorated by line item value per 19 CFR § 152.103).', lineItems: [{ desc: 'Casting Molds (50% value)', declared: '$108,250.00 USD', dutiable: '$105,000.00 USD', tariff: '25%', variance: '+$812.50 USD' }, { desc: 'Steel Die Bases (50% value)', declared: '$108,250.00 USD', dutiable: '$105,000.00 USD', tariff: '10%', variance: '+$325.00 USD' }] },
  { id: 'YAM-8853', status: 'clean', currency: 'USD', supplier: 'Osaka Electronics Co.', incoterm: 'FOB Tokyo', date: '2026-02-20', desc: 'Wiring Harnesses', cooMatchText: 'ACE Match Confirmed', cooStatus: '✓ Matched', htsMatchText: 'ACE Match Confirmed', htsStatus: '✓ Matched', dutiable: '$34,000.00 USD', nondutiable: '$0.00 USD', total: '$34,000.00 USD', declared: '$34,000.00 USD', tariff: '10%', variance: '$0.00', errorType: 'N/A', reason: 'Validation Complete.', logic: 'Standard extraction.' },
  { id: 'YAM-8854', status: 'clean', currency: 'USD', supplier: 'Osaka Electronics Co.', incoterm: 'FOB Tokyo', date: '2026-02-21', desc: 'Wiring Harnesses', cooMatchText: 'ACE Match Confirmed', cooStatus: '✓ Matched', htsMatchText: 'ACE Match Confirmed', htsStatus: '✓ Matched', dutiable: '$34,000.00 USD', nondutiable: '$0.00 USD', total: '$34,000.00 USD', declared: '$34,000.00 USD', tariff: '10%', variance: '$0.00', errorType: 'N/A', reason: 'Validation Complete.', logic: 'Standard extraction.' },
  { id: 'YAM-8855', status: 'clean', currency: 'USD', supplier: 'Osaka Electronics Co.', incoterm: 'FOB Tokyo', date: '2026-02-21', desc: 'Wiring Harnesses', cooMatchText: 'ACE Match Confirmed', cooStatus: '✓ Matched', htsMatchText: 'ACE Match Confirmed', htsStatus: '✓ Matched', dutiable: '$34,000.00 USD', nondutiable: '$0.00 USD', total: '$34,000.00 USD', declared: '$34,000.00 USD', tariff: '10%', variance: '$0.00', errorType: 'N/A', reason: 'Validation Complete.', logic: 'Standard extraction.' },
  { id: 'YAM-8856', status: 'error', currency: 'USD', supplier: 'Fukuoka Assembly', incoterm: 'EXW Fukuoka', date: '2026-02-22', desc: 'Seat Cushions', cooMatchText: 'ACE Match Confirmed', cooStatus: '✓ Matched', htsMatchText: 'ACE Match Confirmed', htsStatus: '✓ Matched', dutiable: '$15,000.00 USD', nondutiable: '$500.00 USD', total: '$15,500.00 USD', declared: '$15,500.00 USD', tariff: '15%', variance: '+$75.00 USD', errorType: 'Foreign Inland Freight', reason: 'CRITICAL: EXW requires foreign inland freight to get goods to the port. That freight is non-dutiable but was included in entered value.', logic: 'Foreign inland transit to port of export is non-dutiable.' },
];

const YamahaLookback = () => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [activeTab, setActiveTab] = useState(1);

  const data = ENTRIES[selectedIndex];

  const getCooClass = (status) => status.includes('Error') ? 'yam-text-red' : 'yam-text-green';
  const getHtsClass = (status) => status.includes('Error') ? 'yam-text-red' : 'yam-text-green';

  const getFxText = (currency) => currency === 'USD' ? 'USD Bypass' : 'Non-USD currency found';
  const getFxStatus = (currency) => currency === 'USD'
    ? { text: '✓ Validated', cls: 'yam-text-green' }
    : { text: '⚠️ FX Review Required', cls: 'yam-text-yellow' };

  const getNonDutiableStatus = (errorType) => errorType === 'N/A'
    ? { text: '✓ Clean Match', cls: 'yam-text-green' }
    : { text: '⚠️ Overpayment Risk', cls: 'yam-text-red' };

  const getCatchHeader = (entry) => {
    if (entry.status === 'error') return { text: `⚠️ Overpayment Detected: Entry #${entry.id}`, cls: 'yam-text-red' };
    if (entry.status === 'warning') return { text: `⚠️ FX Date Review Required: Entry #${entry.id}`, cls: 'yam-text-yellow' };
    return { text: `✓ Clean Ledger: Entry #${entry.id}`, cls: 'yam-text-green' };
  };

  const getCatchCardClass = (status) => {
    if (status === 'error') return 'yam-highlight-row';
    if (status === 'warning') return 'yam-warning-row';
    return 'yam-clean-row';
  };

  const fxStatus = getFxStatus(data.currency);
  const catchHeader = getCatchHeader(data);
  const nonDutiableStatus = getNonDutiableStatus(data.errorType);

  return (
    <Box className="yam-wrapper">

      {/* Top Bar */}
      {/* <Box className="yam-topbar">
        <Typography className="yam-topbar-title">Yamaha Lookback Pilot</Typography>
        <Box className="yam-badge">STAGING ENVIRONMENT - 500 ENTRIES</Box>
      </Box> */}

      {/* Workspace */}
      <Box className="yam-workspace">

        {/* Queue Panel */}
        <Box
          className="yam-queue-panel"
          sx={{ opacity: activeTab === 3 ? 0.3 : 1, pointerEvents: activeTab === 3 ? 'none' : 'auto' }}
        >
          <Box className="yam-queue-header">
            <Typography className="yam-queue-header-title">3rd-Party Broker Queue</Typography>
            <Typography className="yam-flagged-count">84 Flagged</Typography>
          </Box>

          {ENTRIES.map((entry, index) => {
            let dotClass = 'yam-dot-green';
            if (entry.status === 'error') dotClass = 'yam-dot-red';
            if (entry.status === 'warning') dotClass = 'yam-dot-yellow';

            return (
              <Box
                key={entry.id}
                className={`yam-queue-item${selectedIndex === index ? ' yam-selected' : ''}`}
                onClick={() => { setSelectedIndex(index); setActiveTab(1); }}
              >
                <Box className="yam-q-id">
                  <span className={`yam-status-dot ${dotClass}`} />
                  {entry.id}
                </Box>
                <Box className="yam-q-supplier">{entry.supplier} | {entry.incoterm}</Box>
              </Box>
            );
          })}
        </Box>

        {/* Content Panel */}
        <Box className="yam-content-panel">

          {/* Tab Controls */}
          <Box className="yam-demo-controls">
            <button
              className={`yam-demo-btn${activeTab === 1 ? ' yam-active-tab' : ''}`}
              onClick={() => setActiveTab(1)}
            >
              1. AI Document Parsing
            </button>
            <button
              className={`yam-demo-btn${activeTab === 2 ? ' yam-active-tab' : ''}`}
              onClick={() => setActiveTab(2)}
            >
              2. Deterministic Validation
            </button>
            <button
              className={`yam-demo-btn yam-export-tab${activeTab === 3 ? ' yam-active-tab' : ''}`}
              onClick={() => setActiveTab(3)}
            >
              3. Export Ledger
            </button>
          </Box>

          {/* Screen 1: AI Document Parsing */}
          {activeTab === 1 && (
            <Box className="yam-flex-row">

              {/* Left card: Semantic Extraction */}
              <Box className="yam-card yam-w-50">
                <Typography className="yam-card-title">
                  Semantic Extraction: Document Set {data.id}
                </Typography>
                <Box className="yam-doc-parse">
                  <span className="yam-parse-blue">[AI Parse: CI_Page_1_Header]</span><br />
                  Supplier: {data.supplier}<br />
                  Incoterms: {data.incoterm}<br />
                  Date of Export: {data.date}<br /><br />
                  <span className="yam-parse-blue">[AI Parse: CI_Page_3_BOM_Table]</span><br />
                  Description: <strong className="yam-desc-bold">{data.desc}</strong><br />
                  Sub-Total (Goods): {data.dutiable}<br /><br />
                  <span className="yam-parse-red">[AI Parse: CI_Page_4_Footnote_B]</span><br />
                  <em>"Note: Total invoice amount includes {data.errorType} of {data.nondutiable}."</em><br /><br />
                  <span className="yam-parse-blue">[AI Parse: CI_Page_4_Footer]</span><br />
                  <strong>TOTAL INVOICE VALUE:</strong> {data.total}
                  <Box className="yam-source-docs">
                    <span className="yam-source-label">Source Documents (Secure S3 Vault)</span><br />
                    <button type="button" className="yam-doc-link">📄 Commercial Invoice (TokyoMoto_CI_Q3.pdf)</button>
                    <button type="button" className="yam-doc-link">📄 Packing List (PL_Weights_Dims.pdf)</button>
                    <button type="button" className="yam-doc-link">📄 Bill of Lading (Ocean_Waybill_LB.pdf)</button>
                    <button type="button" className="yam-doc-link">📄 Historical ACE 7501 (Entry_Filing.xml)</button>
                  </Box>
                </Box>
              </Box>

              {/* Right card: 19 CFR Compliance */}
              <Box className="yam-card yam-w-50">
                <Typography className="yam-card-title">19 CFR Compliance (5-Point Match)</Typography>
                <Table className="yam-table" size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell className="yam-th">Validation Point</TableCell>
                      <TableCell className="yam-th">Extracted vs 7501</TableCell>
                      <TableCell className="yam-th">Status</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell className="yam-td">1. Country of Origin</TableCell>
                      <TableCell className="yam-td">{data.cooMatchText}</TableCell>
                      <TableCell className={`yam-td ${getCooClass(data.cooStatus)}`}>{data.cooStatus}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className="yam-td">2. Incoterm Logic</TableCell>
                      <TableCell className="yam-td">{data.incoterm}</TableCell>
                      <TableCell className="yam-td yam-text-green">✓ Validated</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className="yam-td">3. HTS Classification</TableCell>
                      <TableCell className="yam-td">{data.htsMatchText}</TableCell>
                      <TableCell className={`yam-td ${getHtsClass(data.htsStatus)}`}>{data.htsStatus}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className="yam-td">4. Foreign Currency (FX) Rule</TableCell>
                      <TableCell className="yam-td">{getFxText(data.currency)}</TableCell>
                      <TableCell className={`yam-td ${fxStatus.cls}`}>{fxStatus.text}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className="yam-td">5. Non-Dutiable</TableCell>
                      <TableCell className="yam-td">{data.nondutiable} ({data.errorType})</TableCell>
                      <TableCell className={`yam-td ${nonDutiableStatus.cls}`}>{nonDutiableStatus.text}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
                <Box className="yam-ai-logic-box">
                  <strong>AI Logic Rule applied:</strong> {data.logic}
                </Box>
              </Box>

            </Box>
          )}

          {/* Screen 2: Deterministic Validation */}
          {activeTab === 2 && (
            <Box className={`yam-card ${getCatchCardClass(data.status)}`}>
              <Typography className={`yam-catch-header ${catchHeader.cls}`}>
                {catchHeader.text}
              </Typography>
              <Table className="yam-table" size="small">
                <TableHead>
                  <TableRow>
                    <TableCell className="yam-th">Line Item Category</TableCell>
                    <TableCell className="yam-th">Broker Declared (7501)</TableCell>
                    <TableCell className="yam-th">Calculated (LusidPay)</TableCell>
                    <TableCell className="yam-th">Tariff Rate</TableCell>
                    <TableCell className="yam-th">Variance</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data.lineItems ? (
                    data.lineItems.map((item, i) => (
                      <TableRow key={i}>
                        <TableCell className="yam-td">{item.desc}</TableCell>
                        <TableCell className="yam-td">{item.declared}</TableCell>
                        <TableCell className="yam-td">{item.dutiable}</TableCell>
                        <TableCell className="yam-td">{item.tariff}</TableCell>
                        <TableCell className={`yam-td ${data.status === 'error' ? 'yam-text-red' : ''}`}>{item.variance}</TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell className="yam-td">{data.desc}</TableCell>
                      <TableCell className="yam-td">{data.declared}</TableCell>
                      <TableCell className={`yam-td ${data.status === 'warning' ? 'yam-text-yellow' : ''}`}>
                        {data.status === 'warning' ? 'TBD - FX Verification Required' : data.dutiable}
                      </TableCell>
                      <TableCell className="yam-td">{data.tariff}</TableCell>
                      <TableCell className={`yam-td ${data.status === 'error' ? 'yam-text-red' : data.status === 'warning' ? 'yam-text-yellow' : ''}`}>
                        {data.variance}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
                {data.lineItems && data.status === 'error' && (
                  <TableFooter>
                    <TableRow className="yam-tfoot-row">
                      <TableCell colSpan={4} align="right" className="yam-tfoot-cell">
                        <strong>Total Entry Overpayment:</strong>
                      </TableCell>
                      <TableCell className="yam-tfoot-cell yam-text-red">
                        <strong>{data.variance}</strong>
                      </TableCell>
                    </TableRow>
                  </TableFooter>
                )}
              </Table>
              <Typography className="yam-catch-reason">{data.reason}</Typography>
            </Box>
          )}

          {/* Screen 3: Export Ledger */}
          {activeTab === 3 && (
            <Box>
              <Box className="yam-metric-grid">
                <Box className="yam-metric-card yam-metric-green">
                  <Typography className="yam-metric-label">TOTAL RECOVERABLE CAPITAL</Typography>
                  <Typography className="yam-metric-value yam-text-green">$362,125.00</Typography>
                </Box>
                <Box className="yam-metric-card yam-metric-blue">
                  <Typography className="yam-metric-label">ENTRIES ANALYZED</Typography>
                  <Typography className="yam-metric-value yam-text-blue">500</Typography>
                </Box>
                <Box className="yam-metric-card yam-metric-red">
                  <Typography className="yam-metric-label">ERRORS FLAGGED</Typography>
                  <Typography className="yam-metric-value yam-text-red">84</Typography>
                </Box>
              </Box>
              <Box className="yam-export-center">
                <button className="yam-primary-btn">
                  ⬇ Export Post Summary Correction (PSC) Ledger
                </button>
              </Box>
            </Box>
          )}

        </Box>
      </Box>
    </Box>
  );
};

export default YamahaLookback;
